<template lang="html">
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-form @submit.prevent="submit()">
        <d-form-row>
          <!-- Name -->
          <d-col md="6" class="form-group">
            <label for="feName">Nome</label>
            <d-form-input
              type="text"
              id="feName"
              placeholder="Nome"
              v-model="model.name"
            />
          </d-col>

          <d-col md="3">
            <d-form-row>
              <!-- Color background -->
              <d-col md="6" class="form-group">
                <label for="feColor">
                  Cor de fundo
                  <small class="text-muted">pdf</small>
                </label>
                <d-form-input
                  type="color"
                  id="feColor"
                  class="feColor"
                  placeholder="Fundo"
                  v-model="model.bgColor"
                />
              </d-col>

              <!-- Color Font-->
              <d-col md="6" class="form-group">
                <label for="feFontColor">
                  Cor fonte (padrão)
                  <small class="text-muted">pdf</small>
                </label>
                <d-form-input
                  type="color"
                  id="feFontColor"
                  class="feColor"
                  placeholder="Fonte"
                  v-model="model.fontColor"
                />
              </d-col>
            </d-form-row>
          </d-col>
          <d-col md="3">
            <d-form-row>
              <!-- Color Font-->
              <d-col md="6" class="form-group">
                <label for="feFontColor">
                  Cor fonte
                  <small class="text-muted">pdf</small>
                </label>
                <d-form-input
                  type="color"
                  id="feFontColor"
                  class="feColor"
                  placeholder="Fonte"
                  v-model="model.fontColor2"
                />
              </d-col>
              <!-- Color background -->
              <d-col md="6" class="form-group">
                <label for="feColor">
                  Cor do título
                  <small class="text-muted">pdf</small>
                </label>
                <d-form-input
                  type="color"
                  id="feColor"
                  class="feColor"
                  placeholder="Fundo"
                  v-model="model.titleColor"
                />
              </d-col>
            </d-form-row>
          </d-col>
        </d-form-row>
        <d-form-row>
          <!-- CNPJ -->
          <d-col md="3" class="form-group">
            <label for="feCNPJ">CNPJ</label>
            <masked-input
              type="text"
              class="text-left form-control"
              :class="['is-' + hasErrorField('cnpj')]"
              id="feCNPJ"
              v-model="model.cnpj"
              placeholder="00.000.000/0000-00"
              :mask="[
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                '.',
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                '.',
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                '/',
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                /[A-Za-z0-9]/,
                '-',
                /\d/,
                /\d/,
              ]"
              :guide="false"
              @input="uppercaseInput('cnpj')"
            />
          </d-col>

          <!-- Email -->
          <d-col md="3" class="form-group">
            <label for="feEmail">Email</label>
            <d-form-input
              :state="hasErrorField('email')"
              type="email"
              id="feEmail"
              placeholder="E-mail"
              v-model="model.email"
            />
          </d-col>

          <!-- Site -->
          <d-col md="3" class="form-group">
            <label for="feSite">Site</label>
            <d-form-input
              type="text"
              id="feSite"
              placeholder="Site"
              v-model="model.site"
            />
          </d-col>

          <!-- Instagram -->
          <d-col md="3" class="form-group">
            <label for="feInstagram">Instagram</label>
            <d-form-input
              type="text"
              id="feInstagram"
              placeholder="Instagram"
              v-model="model.instagram"
            />
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Telefone  Whatsapp-->
          <d-col md="4" class="form-group">
            <label for="feTelefoneWhatsapp1">Telefone 1 Whatsapp</label>
            <input-phone
              id="feTelefoneWhatsapp1"
              placeholder="Telefone"
              :model.sync="model.whatsapp1"
            ></input-phone>
          </d-col>

          <!-- Telefone  Whatsapp-->
          <d-col md="4" class="form-group">
            <label for="feTelefoneWhatsapp2">Telefone 2 Whatsapp</label>
            <input-phone
              id="feTelefoneWhatsapp2"
              placeholder="Telefone"
              :model.sync="model.whatsapp2"
            ></input-phone>
          </d-col>

          <!-- Telefone  Fixo-->
          <d-col md="4" class="form-group">
            <label for="feTelefone">Telefone Fixo</label>
            <input-phone
              id="feTelefone"
              placeholder="Telefone"
              :model.sync="model.phone"
            ></input-phone>
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Endereço -->
          <d-col md="10" class="form-group">
            <label for="feInputEndereco">Endereço</label>
            <d-form-input
              :state="hasErrorField('address')"
              type="text"
              id="feInputEndereco"
              placeholder="Rua,Av,Travessa"
              v-model="model.address"
              @change="capitalizeInput('address')"
            />
          </d-col>

          <!-- Numero -->
          <d-col md="2" class="form-group">
            <label for="feInputNumero">Número</label>
            <d-form-input
              :state="hasErrorField('number')"
              type="text"
              id="feInputNumero"
              placeholder="Número"
              v-model="model.number"
            />
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Bairro -->
          <d-col md="4" class="form-group">
            <label for="feInputBairro">Bairro</label>
            <d-form-input
              :state="hasErrorField('district')"
              type="text"
              id="feInputBairro"
              v-model="model.district"
              @change="capitalizeInput('district')"
            />
          </d-col>

          <!-- Cidade -->
          <d-col md="4" class="form-group">
            <label for="feInputCidade">Cidade</label>
            <d-form-input
              :state="hasErrorField('city')"
              type="text"
              id="feInputCidade"
              v-model="model.city"
              @change="capitalizeInput('city')"
            />
          </d-col>

          <!-- Estado -->
          <d-col md="2" class="form-group">
            <label for="feInputEstado">Estado</label>
            <select-state
              :validate="hasErrorField('state')"
              :model.sync="model.state"
            />
          </d-col>

          <!-- CEP -->
          <d-col md="2" class="form-group">
            <label for="inputCEP">CEP</label>
            <masked-input
              type="text"
              class="text-left form-control"
              id="inputCEP"
              v-model="model.zipcode"
              placeholder="00.000-000"
              :class="['is-' + hasErrorField('zipcode')]"
              :mask="[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
              :guide="false"
            ></masked-input>
          </d-col>
        </d-form-row>

        <d-form-row>
          <d-button type="submit" class="btn-primary">Salvar</d-button>
        </d-form-row>
      </d-form>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import InputPhone from '_shared/InputPhone.vue';
import MaskedInput from 'vue-text-mask';
import SelectState from '_shared/SelectState.vue';
import SettingsService from '_services/rest/modules/settings';
import MixinValidateForm from '_common/mixins/ValidateForm';
import { capitalize } from '_utils/string';
import { _LOAD_MODEL_COMPANY_, COMPANY } from './SettingsModel';

export default {
  name: 'company-form',
  mixins: [MixinValidateForm],
  components: {
    InputPhone,
    MaskedInput,
    SelectState,
  },
  computed: {},
  data() {
    return {
      model: { ...COMPANY },
      loading: false,
      errors: {
        cnpj: { required: false },
        email: { required: false },
        address: { required: false },
        number: { required: false },
        district: { required: false },
        city: { required: false },
        state: { required: false },
        zipcode: { required: false },
      },
    };
  },
  methods: {
    ...mapActions(['activeAlert']),
    capitalizeInput(field) {
      this.model[field] = capitalize(this.model[field]);
    },
    uppercaseInput(field) {
      const value = this.model[field];
      this.model[field] = value ? value.toUpperCase() : value;
    },
    submit() {
      if (this.checkForm()) {
        this.loading = true;
        SettingsService.saveOptions(this.model, 'company')
          .then(() =>
            this.activeAlert({
              message: 'Configurações salvas com sucesso',
              theme: 'success',
            })
          )
          .catch(error => {
            this.activeAlert({
              message: `${error.message} <br/> ${error.data}`,
              theme: 'danger',
            });
          })
          .finally((this.loading = false));
      }
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_COMPANY_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss" scoped>
.feColor {
  height: 37px;
}
</style>
